module.exports = __webpack_public_path__ + "img/getec.a250a340.png";